

<div class="main-container">
    <span style="font-weight:600;font-size: 20px;margin-bottom: 10px;">Gridding History Selection</span>
    <div class="close-btn-container" (click)="close()">
        <img src="../../assets/icons/close.svg" alt="Close Icon" class="close-icon">
    </div>
    

    <mat-divider></mat-divider>

    <div class="header-container-new-gridding-history-selection samples-header">
        <h1 mat-dialog-title  class="new-gridding-history-selection-header"></h1>
    </div>

<div class="sample-group-history-list-container">
      @for (group of fillteredGroups; track group?.id) {
    <div class="gridding-history-selection-sample-list-container">
        <mat-card class="gridding-history-selection-item-card">
            <div class="gridding-history-selection-sample-content-container">

              
                <div class="gridding-history-selection-sample-text-container">
                    <div class="sample-name-text-container">
                        <p class="gridding-history-selection-sample-item-bold-text">Group name : </p><p class="gridding-history-selection-sample-details-text">{{group?.name ? group?.name : '-'}}
</p>
                        <span class="gridding-history-selection-sample-text-splitter"> | </span>
                        <p class="gridding-history-selection-sample-item-bold-text">Date Created :</p><p class="gridding-history-selection-sample-details-text">{{dayjs(group?.dateCreated).format(dateStringFormatting) ? dayjs(group?.dateCreated).format(dateStringFormatting) : '-'}}</p>
                    </div>
                </div>
                <div class="gridding-history-selection-sample-btn-container">

                    <div class="gridding-history-selection-sample-btn-container">
                        <button class="delete-gridding-history-selection-sample-small-btn" mat-flat-button type="button"  (click)="openDeleteGroupDialog(group)">
                            <div class="gridding-history-selection-sample-item-content">
                                <img src="../../assets/icons/delete.svg" alt="Delete Icon" class="new-gridding-history-selection-btn-icon">
                            </div>
                        </button>
                    </div>

                    <div class="gridding-history-selection-sample-btn-container">
                        <button class="edit-gridding-history-selection-sample-small-btn" mat-flat-button type="button"  (click)="openEditGroupDialog(group)">
                            <div class="gridding-history-selection-sample-item-content">
                                <img src="../../assets/icons/edit.svg" alt="Edit Icon" class="new-gridding-history-selection-btn-icon">
                            </div>
                        </button>
                    </div>

                    <div class="gridding-history-selection-sample-btn-container">
                        <button class="edit-gridding-history-selection-sample-small-btn" mat-flat-button type="button"  (click)="viewHistory(group)">
                            <div class="gridding-history-selection-sample-item-content">
                                <img src="../../assets/icons/view-eye.svg" alt="Edit Icon" class="new-gridding-history-selection-btn-icon">
                            </div>
                        </button>
                    </div>
                </div>
            </div>
        </mat-card>
    </div>
      }
 </div>
</div>


